import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';

export const WithdrawalPaymentFilesBreadcrumb = () => {
  const { t } = useTranslation('withdrawalPaymentFilesModule');
  const { t: tWithdrawals } = useTranslation('withdrawalsModule');

  const breadcrumbs = useMemo<BreadcrumbItem[]>(
    () => [
      { label: tWithdrawals('breadcrumbs.withdrawals'), path: '/wallets/withdrawals' },
      { label: t('breadcrumbs.paymentFiles') },
    ],
    [t, tWithdrawals],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
